<template>
  <main class="home-container">
    <div class="welcome-section">
      <div class="welcome-content">
        <h1 class="welcome-title">
          <i class="fas fa-seedling mr-3"></i>
          Seja bem-vindo(a)!
        </h1>
        <p class="welcome-subtitle">
          {{ getUserGreeting() }}
        </p>
        <p class="welcome-message">
          Utilize o menu lateral para acessar as funcionalidades do sistema Brasil Agritest
        </p>
      </div>
    </div>

    <div class="quick-stats">
      <div class="stat-card" v-for="stat in quickStats" :key="stat.title">
        <div class="stat-icon">
          <i :class="stat.icon"></i>
        </div>
        <div class="stat-info">
          <h3 class="stat-title">{{ stat.title }}</h3>
          <p class="stat-description">{{ stat.description }}</p>
        </div>
      </div>
    </div>

    <div class="quick-actions">
      <h2 class="section-title">Acesso Rápido</h2>
      <div class="actions-grid">
        <router-link
          v-for="action in quickActions"
          :key="action.route"
          :to="action.route"
          class="action-card"
        >
          <div class="action-icon">
            <i :class="action.icon"></i>
          </div>
          <h3 class="action-title">{{ action.title }}</h3>
          <p class="action-description">{{ action.description }}</p>
        </router-link>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  computed: {
    quickStats () {
      return [
        {
          icon: 'fas fa-flask',
          title: 'Análises de Qualidade',
          description: 'Sistema completo de análise de produtos agrícolas'
        },
        {
          icon: 'fas fa-chart-line',
          title: 'Relatórios Detalhados',
          description: 'Acompanhamento e estatísticas em tempo real'
        },
        {
          icon: 'fas fa-shield-alt',
          title: 'Controle de Qualidade',
          description: 'Padrões e certificações garantidas'
        }
      ]
    },
    quickActions () {
      const actions = []

      if (this.$store.getters.isSuperAdmin) {
        actions.push(
          { route: '/analises', icon: 'fas fa-microscope', title: 'Análises', description: 'Visualizar todas as análises' },
          { route: '/melhorias', icon: 'fas fa-tools', title: 'Operacional', description: 'Métricas operacionais' },
          { route: '/empresas', icon: 'fas fa-building', title: 'Empresas', description: 'Gerenciar empresas' },
          { route: '/equipamentos', icon: 'fas fa-tools', title: 'Equipamentos', description: 'Controlar equipamentos' },
          { route: '/funcionarios', icon: 'fas fa-user-tie', title: 'Equipe', description: 'Gerenciar funcionários' }
        )
      } else if (this.$store.getters.isReadOnly) {
        actions.push(
          { route: '/analises', icon: 'fas fa-microscope', title: 'Análises', description: 'Visualizar análises' },
          { route: '/melhorias', icon: 'fas fa-tools', title: 'Operacional', description: 'Métricas operacionais' },
          { route: '/empresas', icon: 'fas fa-building', title: 'Empresas', description: 'Visualizar empresas' },
          { route: '/equipamentos', icon: 'fas fa-tools', title: 'Equipamentos', description: 'Visualizar equipamentos' },
          { route: '/funcionarios', icon: 'fas fa-user-tie', title: 'Equipe', description: 'Visualizar funcionários' }
        )
      } else if (this.$store.getters.isManager) {
        actions.push(
          { route: '/analises', icon: 'fas fa-microscope', title: 'Análises', description: 'Visualizar análises' },
          { route: '/melhorias', icon: 'fas fa-tools', title: 'Operacional', description: 'Métricas operacionais' },
          { route: '/funcionarios', icon: 'fas fa-user-tie', title: 'Equipe', description: 'Gerenciar funcionários' },
          { route: '/estatisticas', icon: 'fas fa-chart-line', title: 'Estatísticas', description: 'Ver relatórios' }
        )
      } else {
        actions.push(
          { route: '/analises', icon: 'fas fa-microscope', title: 'Análises', description: 'Visualizar análises' }
        )
      }

      return actions
    }
  },
  methods: {
    getUserGreeting () {
      const hour = new Date().getHours()
      let greeting = 'Bom dia'
      if (hour >= 12 && hour < 18) greeting = 'Boa tarde'
      else if (hour >= 18) greeting = 'Boa noite'

      const userName = this.$store.state.user?.name || 'Usuário'
      return `${greeting}, ${userName}!`
    }
  }
}
</script>

<style scoped>
.home-container {
  animation: fadeIn 0.5s ease-in;
  padding: 20px 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.welcome-section {
  background: linear-gradient(135deg, #FF8C42 0%, #FF7A29 100%);
  border-radius: 20px;
  padding: 60px 40px;
  text-align: center;
  box-shadow: 0 8px 30px rgba(255, 140, 66, 0.3);
  margin-bottom: 40px;
  position: relative;
  overflow: hidden;
}

.welcome-section::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -10%;
  width: 400px;
  height: 400px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
}

.welcome-section::after {
  content: '';
  position: absolute;
  bottom: -30%;
  left: -5%;
  width: 300px;
  height: 300px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 50%;
}

.welcome-content {
  position: relative;
  z-index: 1;
}

.welcome-title {
  font-size: 3rem;
  font-weight: 700;
  color: white;
  margin-bottom: 15px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.welcome-subtitle {
  font-size: 1.5rem;
  color: white;
  margin-bottom: 10px;
  font-weight: 600;
}

.welcome-message {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.95);
  max-width: 700px;
  margin: 0 auto;
}

.quick-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 25px;
  margin-bottom: 50px;
}

.stat-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 15px;
  padding: 25px;
  display: flex;
  align-items: center;
  gap: 20px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
}

.stat-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #FF8C42 0%, #FF7A29 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stat-icon i {
  font-size: 1.8rem;
  color: white;
}

.stat-info {
  flex: 1;
}

.stat-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 5px;
}

.stat-description {
  font-size: 0.95rem;
  color: #6c757d;
  margin: 0;
}

.section-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 30px;
}

.actions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 25px;
}

.action-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 15px;
  padding: 30px 25px;
  text-align: center;
  transition: all 0.3s ease;
  text-decoration: none;
  color: inherit;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  border: 2px solid transparent;
}

.action-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 35px rgba(255, 140, 66, 0.25);
  border-color: #FF8C42;
  text-decoration: none;
}

.action-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #FF8C42 0%, #FF7A29 100%);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 140, 66, 0.3);
}

.action-card:hover .action-icon {
  transform: scale(1.1) rotate(5deg);
}

.action-icon i {
  font-size: 2.2rem;
  color: white;
}

.action-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 10px;
}

.action-description {
  font-size: 0.95rem;
  color: #6c757d;
  margin: 0;
}

@media (max-width: 768px) {
  .welcome-title {
    font-size: 2rem;
  }

  .welcome-subtitle {
    font-size: 1.2rem;
  }

  .quick-stats {
    grid-template-columns: 1fr;
  }

  .actions-grid {
    grid-template-columns: 1fr;
  }
}
</style>
